import React from "react";
import { useTranslation } from "react-i18next";

const EmptyCartMessage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="empty-cart-message">
      <p>{t("cart.emptyMessage", "Your cart is currently empty.")}</p>
      <a href="/shop" className="button continue-shopping-button">
        {t("cart.continueShopping", "Continue Shopping")}
      </a>
    </div>
  );
};

export default EmptyCartMessage;
